/**
 * @file Automatically generated by barrelsby.
 */

export * from './loan-chart.component';
export * from './loan-chart.module';
